import { PaginationResponse, api } from './api';
import { OptionEntity } from './optionApi';

export enum LlmModelSize {
  ECO = 'ECO', // economic
  ADV = 'ADV', // advanced
}

export enum INTERVIEW_TYPE {
  // BASE = 0,
  SINGLE_SELECTION = 1,
  MULTIPLE_SELECTION = 2,
  DROPDOWN = 4,
  RANGE_SELECTION = 3,
  AI = 5,
  DATE = 6,
  CONFIRM = 7,
  LOCATION = 8,
}

export const INTERVIEW_TYPE_STR = Object.fromEntries(
  Object.entries(INTERVIEW_TYPE).map(([key, value]) => [value, key])
);

export const INTERVIEW_CONDITIONS_LIST = [
  'always',
  'equals',
  'notEquals',
  'contains',
  'notContains',
];

export enum INTERVIEW_CONDITIONS {
  always = 'always',
  equals = 'equals',
  notEquals = 'notEquals',
  contains = 'contains',
  notContains = 'notContains',
}

export interface QuestionConfig {
  skipRandomStart?: boolean;
  completeWithComment?: boolean;
  llmModal?: LlmModelSize;
  default1?: number;
  default2?: number;
  disableOther?: boolean;
  additionalPrompt?: string;
}

export interface InterviewCondition {
  type?: INTERVIEW_CONDITIONS;
  field?: string;
  value?: number;
}

export interface InterviewEntity {
  id: number;
  sequence: number;
  name: string;
  condition: InterviewCondition;
  type: INTERVIEW_TYPE;
  prefillAnswers: Record<string, string>[]; // { en: 'en_a', cn: 'cn_a' }[]
  question: Record<string, string>;
  questionConfig: QuestionConfig;
  option?: OptionEntity;
  optionId?: number;
  collect: [string, Record<string, string> | undefined, string | undefined][]; // ['name', {en: 'en_c', cn: 'cn_c'}, 'number/boolean/string'?][]
  disabled: boolean;
  useAsSummary?: boolean;
  placeholder: Record<string, string>;
  sectionId: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface FindManyInterviewResponse extends PaginationResponse {
  data: InterviewEntity[];
}

export interface UpdateInterviewResponse {
  record: InterviewEntity;
  needReloadAll: boolean;
}

export const interviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    findManyInterviews: builder.query<FindManyInterviewResponse, void>({
      query: () => ({
        url: '/interviews',
        method: 'GET',
      }),
    }),
    createInterview: builder.mutation<
      UpdateInterviewResponse,
      Partial<InterviewEntity>
    >({
      query: (body) => ({
        url: '/interviews',
        method: 'POST',
        body,
      }),
    }),
    updateInterview: builder.mutation<
      UpdateInterviewResponse,
      Partial<InterviewEntity>
    >({
      query: ({ id, ...body }) => ({
        url: `/interviews/${id}`,
        method: 'PATCH',
        body,
      }),
    }),
    deleteInterview: builder.mutation<void, number>({
      query: (id) => ({
        url: `/interviews/${id}`,
        method: 'DELETE',
      }),
    }),
    downloadDatabase: builder.query<any, void>({
      query: () => ({
        url: '/interviews/download',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useFindManyInterviewsQuery,
  useCreateInterviewMutation,
  useUpdateInterviewMutation,
  useDeleteInterviewMutation,
  useLazyDownloadDatabaseQuery,
} = interviewApi;
